export default {
  'components.DatePicker.clear': 'ลบ',
  'components.DatePicker.cancel': 'ยกเลิก',
  'components.DatePicker.choose': 'กรุณาเลือกวันที่',
  'components.DatePicker.confirm': 'ยืนยัน',
  'components.Dialog.no': 'ไม่',
  'components.LoginFailed.title': 'การเข้าสู่ระบบล้มเหลว',
  'components.LoginFailed.notice': 'กรุณาปิดแล้วเปิดหน้านี้ใหม่',
  'components.Maintenance.title': 'ระบบอยู่ระหว่างการบำรุงรักษา',
  'components.Maintenance.notice': 'กรุณาลองใหม่อีกครั้ง',
  'components.Maintenance.refresh': 'รีเฟรช',
  'components.MenuTabBar.ticket': 'ตั๋ว',
  'components.MenuTabBar.my': 'ของฉัน',
  'components.MenuTabBar.menu_item.more': 'เพิ่มเติม',
  'components.MenuTabBar.menu_item.home': 'หน้าแรก',
  'components.MenuTabBar.menu_item.member_card': 'บัตรสมาชิก',
  'components.MenuTabBar.menu_item.coupon': 'คูปอง',
  'components.MenuTabBar.menu_item.store': 'ร้านค้า',
  'components.MenuTabBar.menu_item.store_value_card': 'บัตรเติมเงิน',
  'components.MenuTabBar.menu_item.loyalty_card': 'บัตรสะสมแต้ม',
  'components.MenuTabBar.menu_item.member_area': 'บัญชีผู้ใช้',
  'components.MenuTabBar.external_open_failed': 'ไม่สามารถเปิดลิงก์นี้ได้ โปรดลองอีกครั้งในภายหลัง',
  'components.NotFound.title': 'ไม่พบข้อมูลร้านค้านี้',
  'components.NotFound.notice': 'คุณสามารถคลิกปุ่มด้านล่างเพื่อลองค้นหาอีกครั้ง',
  'components.OpenInLINE.browser_invalid': 'ไม่สามารถใช้ Echoss VIP ผ่านเบราว์เซอร์นี้',
  'components.OpenInLINE.guide.title': 'กรุณาตั้งค่าตามคำแนะนำด้านล่าง:',
  'components.OpenInLINE.guide.step.one': '1. เปิด "การตั้งค่า" ในแอป LINE',
  'components.OpenInLINE.guide.step.two': '2. เข้าไปที่ "LINE Labs"',
  'components.OpenInLINE.guide.step.three':
    '3. ปิดการใช้งานและ "กรุณาเปิดลิงก์ผ่านเบราว์เซอร์เริ่มต้น"',
  'components.OpenInLINE.guide.finish':
    'เมื่อดำเนินการเสร็จสิ้น กรุณาคลิกลิงก์อีกครั้งเพื่อเข้าสู่ระบบ',
  'components.OpenInLINE.qr.title': 'ฟีเจอร์สำหรับแอป LINE เท่านั้น',
  'components.OpenInLINE.qr.scan': 'โปรดใช้ LINE สแกนคิวอาร์โค้ดเพื่อดูเนื้อหา',
  'components.OpenInLINE.qr.brand_message':
    'ไม่ต้องติดตั้ง ไม่ต้องเข้าสู่ระบบ! ใช้ "{brandName}" ได้ทันทีบน LINE!',
  'components.OTPPhone.ManualOTPDialog.enter_verification_code':
    'กรุณากรอกรหัสยืนยัน 4 หลักที่รับจากร้านค้า',
  'components.OTPPhone.verification_fail': 'การยืนยันล้มเหลว',
  'components.OTPPhone.resend_seconds': 'กรุณาลองใหม่อีกครั้งใน {seconds} วินาที',
  'components.OTPPhone.send_verification_code': 'ส่งรหัสยืนยัน',
  'components.OTPPhone.auth_code.required': 'กรุณากรอกรหัสยืนยัน',
  'components.OTPPhone.message_unreceived': 'ไม่ได้รับข้อความ?',
  'components.OTPPhone.message_auth_code': 'รหัสยืนยันทาง SMS',
  'components.OTPPhone.verified': 'ยืนยันสำเร็จ',
} as Record<string, string>;
